import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { CasinoOutlined } from '@mui/icons-material';

const CmmKolkataLogo: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        ...style,
      }}
    >
      {/* Roulette Icon */}
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: 'spin 3s linear infinite',
          '@keyframes spin': {
            '0%': {
              transform: 'rotate(0deg)',
            },
            '100%': {
              transform: 'rotate(360deg)',
            },
          },
        }}
      >
        <CasinoOutlined
          sx={{
            fontSize: '2rem',
            color: theme.palette.primary.main,
            fontWeight: 900,
          }}
        />
      </Box>

      {/* Text Logo */}
      <Typography
        sx={{
          fontFamily: 'Poppins',
          fontWeight: 900,
          fontSize: '1.5rem',
          lineHeight: 1,
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          textTransform: 'uppercase',
          letterSpacing: '1px',
        }}
      >
        CMM
        <Typography
          component="span"
          sx={{
            fontFamily: 'Poppins',
            fontWeight: 700,
            fontSize: '1.5rem',
            marginLeft: '4px',
            background: `linear-gradient(135deg, ${theme.palette.info.main} 0%, ${theme.palette.secondary.main} 100%)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Kolkata
        </Typography>
      </Typography>
    </Box>
  );
};

export default CmmKolkataLogo;

